<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">팝업상세</h4>
        </template>

        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">(NEW)한국어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="newImageFileId | blipImageUrl" @onChangeFileIds="onNewFileIdChange" />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">(NEW)영어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="newImageFileEnId | blipImageUrl" @onChangeFileIds="onNewFileIdEnChange" />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">(NEW)일본어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="newImageFileJaId | blipImageUrl" @onChangeFileIds="onNewFileIdJaChange" />
              </div>
            </div>
          </div>
        </div>
        <div class="row has-image">
          <label class="col-sm-2 col-form-label">이름</label>
          <div class="col-sm-10">
            <base-input placeholder="이름" v-model="name">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">링크</label>
          <div class="col-sm-10">
            <LinkSelect @linkChangeEvent="getLink" class="link-selection" link-model="link" />
            <base-input placeholder="링크" v-model="link">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출시작시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출종료시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">팝업그룹</label>
          <div class="col-sm-10">
            <base-input placeholder="그룹" v-model="group">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">팝업노출국가</label>
          <div class="col-sm-10 checkbox-radios">
            <collapse>
              <collapse-item title="팝업노출국가 선택" class="text-left">
                <div class="row">
                  <base-button @click="selectAllCodes" type="default">모두선택</base-button
                  ><base-button @click="unselectAllCodes" type="default">모두해제</base-button>
                </div>
                <span v-for="(n, index) in countryCodes" :key="index">
                  <base-checkbox v-model="countryCodes[index].value" inline>{{ n.name }}</base-checkbox>
                </span>
              </collapse-item>
            </collapse>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">노출 아티스트</label>
          <div class="col-sm-10 checkbox-radios">
            <collapse>
              <collapse-item title="아티스트 선택" class="text-left">
                <span v-for="(n, index) in units" :key="index">
                  <base-checkbox v-model="units[index].value" inline>{{ n.blipName }}</base-checkbox>
                </span>
              </collapse-item>
            </collapse>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
      <base-button v-if="popupId && state === 1" @click="setPopupState(0)" type="default">숨김</base-button>
      <base-button v-if="popupId" @click="setPopupState(-1)" type="danger">삭제</base-button>
      <base-button v-if="popupId && state === 0" @click="setPopupState(1)" type="default">표시</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card, Collapse, CollapseItem } from "@/components/index";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { Toast } from "@/util/Toast";
import LinkSelect from "@/pages/Components/LinkSelect.vue";

export default {
  components: {
    CollapseItem,
    Collapse,
    Card,
    BaseInput,
    LinkSelect,
    BlipFileUploadZone,
  },
  async created() {
    await this.getAllUnits();
    try {
      await this.getCountryCodes();
    } catch (e) {}
    if (this.$route.query.popupId) {
      this.popupId = Number(this.$route.query.popupId);
      await this.getData();
    }
  },
  data() {
    return {
      group: null,
      popupId: null,
      name: null,
      imageFileId: null,
      imageFileEnId: null,
      imageFileJaId: null,
      newImageFileId: null,
      newImageFileEnId: null,
      newImageFileJaId: null,
      link: null,
      startTime: null,
      endTime: null,
      countryCodes: [],
      state: 1,
      units: [],
    };
  },
  methods: {
    onNewFileIdChange(newFileIds) {
      this.newImageFileId = newFileIds[0];
    },
    onNewFileIdEnChange(newFileIds) {
      this.newImageFileEnId = newFileIds[0];
    },
    onNewFileIdJaChange(newFileIds) {
      this.newImageFileJaId = newFileIds[0];
    },
    async getAllUnits() {
      return this.$axios.get(`/artistUnit`).then((res) => {
        const data = res.data.data;
        this.units = data
          .filter((d) => d.unitId !== this.unitId)
          .map((d) => {
            d.value = false;
            return d;
          });
      });
    },
    async getCountryCodes() {
      return this.$axios.get(`/common/countryCodes`).then((res) => {
        const data = res.data.data;
        this.countryCodes = data.map((d) => {
          d.value = false;
          return d;
        });
      });
    },

    selectAllCodes() {
      for (const countryCode of this.countryCodes) {
        countryCode.value = true;
      }
    },
    unselectAllCodes() {
      for (const countryCode of this.countryCodes) {
        countryCode.value = false;
      }
    },
    async getData() {
      return this.$axios.get(`/popup/${this.popupId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.name = data.name;
          this.imageFileId = data.imageFileId;
          this.imageFileEnId = data.imageFileEnId;
          this.imageFileJaId = data.imageFileJaId;
          this.link = data.link;
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.group = data.group;
          this.state = data.state;
          const images = data.images;
          this.newImageFileId = images.find((i) => i.code === "ko").imageFileId;
          this.newImageFileEnId = images.find((i) => i.code === "en").imageFileId;
          this.newImageFileJaId = images.find((i) => i.code === "ja").imageFileId;

          if (data.countryCodes) {
            const countryCodes = data.countryCodes.split(",");
            this.countryCodes.forEach((code) => {
              for (const countryCode of countryCodes) {
                if (countryCode === code.isoCode) {
                  code.value = true;
                }
              }
            });
          }

          if (data.unitIds) {
            const unitIds = data.unitIds.split(",").map((d) => Number(d));
            this.units.forEach((unit) => {
              for (const unitId of unitIds) {
                if (unitId === unit.unitId) {
                  unit.value = true;
                }
              }
            });
          }
        }
      });
    },
    async setPopupState(state) {
      return this.$axios
        .put(`/popup/${this.popupId}/state`, {
          params: { state },
        })
        .then((res) => {
          Toast.success("상태가 변경되었습니다");
          this.state = state;
        });
    },
    getLink(param) {
      const linkModel = param.linkModel.split(".");
      this[linkModel[0]] = param.value;
    },
    async onSubmit() {
      if (!this.newImageFileId || !this.newImageFileEnId || !this.newImageFileJaId) {
        Toast.error("이미지는 필수입니다");
        return;
      }
      if (!this.startTime || !this.endTime) {
        Toast.error("시간을 입력해주세요");
        return;
      }

      if (new Date(this.startTime) > new Date(this.endTime)) {
        Toast.error("종료시간이 시작시간보다 빨라요");
        return;
      }

      const countryCodes = [];
      this.countryCodes.forEach((u) => {
        if (u.value) {
          countryCodes.push(u.isoCode);
        }
      });
      const units = [];
      this.units.forEach((u) => {
        if (u.value) {
          units.push(u.unitId);
        }
      });
      const params = {
        name: this.name,
        imageFileId: this.imageFileId,
        imageFileEnId: this.imageFileEnId,
        imageFileJaId: this.imageFileJaId,
        images: [
          { code: "ko", imageFileId: this.newImageFileId },
          { code: "en", imageFileId: this.newImageFileEnId },
          { code: "ja", imageFileId: this.newImageFileJaId },
        ],
        link: this.link,
        group: this.group,
        startTime: this.startTime,
        endTime: this.endTime,
        state: this.state,
        countryCodes: countryCodes.length > 0 ? countryCodes.toString() : null,
        unitIds: units.length > 0 ? units.toString() : null,
      };
      try {
        if (this.popupId) {
          await this.$axios.put(`/popup/${this.popupId}`, params);
          Toast.success("팝업이 수정되었습니다");
        } else {
          await this.$axios.post("/popup", params);
          Toast.success("팝업이 등록되었습니다");
        }
        this.$router.push(`/banner/popup`);
      } catch (e) {
        console.log(e);
        Toast.error(`처리중 에러가 발생하였습니다`);
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.has-image {
  padding-top: 100px;
}
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
